
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ProgressTile extends Vue {
  show: boolean = false;
  @Prop(Number) current!: number;
  @Prop(Number) total!: number;
  @Prop(String) title!: string;
}
